import React, { useState } from "react";
import PropTypes from "prop-types";
import { Redirect, withRouter } from "react-router-dom";
import {  Button } from "@blueprintjs/core";
import "./Logout.css";

import WebNetButton from "./WebNetButton";

import { useTranslation } from 'react-i18next';

//require('dotenv').config();

const Logout = ({ logout }) => {
    const [error, setError] = useState("");
    const [loggedOut, setLoggedOut] = useState(false);
    const [backViewer, SetBackViewer] = useState(false);

    const { t } = useTranslation();

    const doLogout =  () => {
        try {
            console.log("Is logging out");
            setLoggedOut(true);
            logout();
          
        } catch (e) {
            setError("Failed to logout", e.message);
        }
    };

    const backToViewer = async () => {
        SetBackViewer(true);
    }

    if (loggedOut) {
        console.log("Redirect to");
        //return <Redirect to="/login"  />
        
    }

    if (backViewer) {
        return <Redirect to="/viewer" />

    }

    return (

        <div className="parent">
            <h1>{t("Are you sure you want to logout?")}</h1>
            <WebNetButton neverActive={false} path="/" onClick={doLogout} text={t("Logout")} />
            <WebNetButton neverActive={false} path="/viewer" onClick={backToViewer} text={t("Cancel")} />
            {error !== "" ? <span className="error"> {error} </span> : ""}
        </div>
    );
};


Logout.propTypes = {
  logout: PropTypes.func.isRequired
};

export default withRouter(Logout);
